import React, { useEffect, useState } from 'react';
import { IOption, ISwatchContent } from '../../types/customizer';
import { extendTailwindMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { defaultRingUrls } from '../../../utils/basic';
import If from "../If";
import { useLocation, useNavigate } from 'react-router-dom';
import { useRingCustomizerContext } from '../../context/RingCustomizerContext';
export interface IBoxFilterProps {
  match: any;
  location: any;
  history: any;
  content: ISwatchContent;
  onChange: (updated: any) => void;
  onSidebarChange?: (key: string) => void;
  innerTab?: number;
  isFetching: boolean;
 };
 const twMerge = extendTailwindMerge({prefix: 'tw-'})
const BoxFilter = ({ content, onChange, isFetching, onSidebarChange, ...rest }: IBoxFilterProps) => {
  const options: Array<IOption> = content.options as Array<IOption>;
  const { fieldType } = content;

  const { params, isQueryHandling } = useRingCustomizerContext();
  const [isChanging, setIsChanging] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
      if (!isFetching) {
        setIsChanging('');
      }
  }, [isFetching]);

  const handleChange = (option: IOption) => () => {
      const sidebarMap: Record<string, string> = {
        band: 'material',
        womens: 'anniversary_style',
        signet: 'shape',
        collegiate_signet: 'logo'
      };
      if (option.selected) {
        const nextSidebar = sidebarMap[option.sku];

        if (nextSidebar) {
          console.log('nextSidebar', nextSidebar)
          onSidebarChange?.(nextSidebar);
        }

        return;
      }
      if(!option.selected) {
        if(fieldType === 'category') {
          switch (option.sku) {
            case 'band':
              navigateToUrl(defaultRingUrls.band);
              break;
            case 'womens':
              navigateToUrl(defaultRingUrls.womens);
              break;
            case 'collegiate_signet':
              navigateToUrl(defaultRingUrls.collegiate_signet);
              break;
            case 'signet':
              navigateToUrl(defaultRingUrls.signet);
              break;
            default:
              break;
          }
        } else if(fieldType === 'types') {
          switch (option.sku) {
            case 'collegiate_signet':
              navigateToUrl(defaultRingUrls.collegiate_signet);
              break;
            case 'collegiate_bands':
              navigateToUrl(defaultRingUrls.collegiate_bands);
              break;
            default:
              break;
          }
        }
        setIsChanging(option.sku); // used for deseclecting old one till response recieved
      }
      // onChange(updatedObj);
  };

  const navigateToUrl = (URL: string, replace = true) => {
    const { pathprefix, subpath } = params.pathParams;
    let navigateUrl = URL;
    if(pathprefix && subpath) {
      navigateUrl = `/${pathprefix}/${subpath}${URL}`;
    } else if(subpath){
      navigateUrl = `/${subpath}${URL}`;
    }

    if(isQueryHandling) {
      navigateUrl = `${location.pathname}?ring_url=${encodeURIComponent(navigateUrl)}`;
    }

    const otherQueryString = new URLSearchParams(params.otherQueryParams).toString();
    if(otherQueryString) {
      navigateUrl += `&${otherQueryString}`;
    }
    navigate(navigateUrl, { replace: replace }); // After URL is navigated it calls a useffect of location dependencies
  }

  return (
      <div className="tw-h-full tw-overflow-auto">
        <div className='tw-flex tw-flex-wrap tw-px-6 tw-py-4 swatch-filter-border lg:tw-gap-y-6 md:tw-gap-y-4 xs:tw-gap-y-2'>
          {options.map((option: IOption, index: number) => (
            <div className={clsx('tw-relative xl:tw-w-1/4 lg:tw-w-1/3 tw-w-1/2 tw-px-3')}>
              <div role="presentation" onClick={handleChange(option)} className={twMerge(clsx({
                'tw-flex tw-flex-col tw-justify-center tw-items-center tw-border tw-border-solid tw-border-gray-400 tw-rounded tw-cursor-pointer': true,
                'tw-border-dashed tw-border-black': option.selected && !isChanging,
                'selected-border-square': isChanging === option.sku
              }))}>
                <If condition={!option.selected || !option.video_url}>
                  <img src={option.swatch_url} alt={option.name} className='tw-w-full tw-aspect-[1.14/1] tw-p-2'/>
                </If>
                <If condition={option.selected && !!option.video_url}>
                  <video src={option.video_url} autoPlay={true} loop={true} playsInline={true} className='tw-w-full tw-aspect-[1.14/1] tw-p-2 tw-object-cover'/>
                </If>
                <div className='secondary-font-family tw-text-sm tw-mb-2'>{option.name}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
  );
};
export default BoxFilter;